export const isProduction = process.env.REACT_APP_ENV === 'prod';
export const isStaging = process.env.REACT_APP_ENV === 'stage';
export const isUat = process.env.REACT_APP_ENV === 'uat';
export const isDev = process.env.REACT_APP_ENV === 'dev';
